import React from 'react';
import style from './style.scss';
export const MagazineIssueCard = ({ issue }) => (React.createElement("a", { href: issue.link || '', target: "_blank", rel: "noopener noreferrer" },
    React.createElement("div", { className: style.card },
        React.createElement("img", { src: `${issue.coverImageUrl}?w=300&h&h=390`, width: "300", height: "390" }),
        React.createElement("div", { className: style.info },
            React.createElement("h4", { className: style.h4 }, issue.magazine.name),
            React.createElement("h3", { className: style.h3 }, issue.title)))));
